module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"author":"Author","date":"Creation date","site":"Site"}}')
  delete Component.options._Ctor
}
